/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Teams_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Which projects and spaces the team can reach, and which AI models its members may use, which overrides the org's base set for them. Enterprise orgs can auto-..." |
*
* @param {Uno_Edu_Intro_Teams_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_teams_chip2_answer = /** @type {((inputs?: Uno_Edu_Intro_Teams_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Teams_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf welche Projekte und Spaces das Team zugreifen kann und welche KI-Modelle seine Mitglieder nutzen dürfen, was den Basissatz der Organisation für sie überschreibt. Enterprise-Organisationen können Mitglieder per SCIM automatisch bereitstellen.")
	return /** @type {LocalizedString} */ ("Which projects and spaces the team can reach, and which AI models its members may use, which overrides the org's base set for them. Enterprise orgs can auto-provision members via SCIM.")
});